export default __webpack_public_path__ + "static/media/archi_slider_10.c71dc398.webp";